export default __webpack_public_path__ + "static/media/bg-11.5d32095a.jpg";